import { LereToursPricingHistoryRecord, LereToursPricingSuggestion } from './types';

type LegacyToursPricingSuggestionSample = Omit<
  LereToursPricingSuggestion,
  'suggested_after_price' | 'sales_at_current_price' | 'departure_salesforce_bk'
> & {
  after_price: number;
  sales_at_current_price?: number;
};

const TOURS_PRICING_BASE_SAMPLE_DATA: Array<LegacyToursPricingSuggestionSample> = [
  {
    suggestion_id: '0206690e-757b-45e5-be63-d9601a648555|2026-09-08|surcharge|0.03',
    suggested_action_type: 'surcharge',
    distance_category: 'close',
    offer_bk: '0206690e-757b-45e5-be63-d9601a648555',
    offer_country_name: 'Italy',
    max_pax: 40.0,
    offer_name: 'Signature Series - Italy w/ Matt and Gary',
    offer_salesforce_bk: '006RF00000LVXdAYAX',
    departure_name: 'September 2026',
    total_pax_sold: 11,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.275,
    hedged_pax: 80.0,
    departure_date: '2026-09-08',
    handback_date: '2026-05-11',
    leadtime: 150,
    offer_url: null,
    original_tour_price: 5499,
    predicted_total_pax: 'Predicted Sold Out',
    suggested_price_change_percent: 0.03,
    suggested_price_change_amount: 164.97,
    after_price: 5663.97,
  },
  {
    suggestion_id: '03011881-22e4-4454-9f55-797c972095c0|2026-05-11|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '03011881-22e4-4454-9f55-797c972095c0',
    offer_country_name: 'Spain',
    max_pax: 24.0,
    offer_name: 'LTLE - 16D Spain & Portugal PLUS Azamara South of France Cruise 2026',
    offer_salesforce_bk: '006RF00000KpYnLYAV',
    departure_name: 'May 2026',
    total_pax_sold: 4,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.167,
    hedged_pax: 76.0,
    departure_date: '2026-05-11',
    handback_date: '2026-03-05',
    leadtime: 30,
    offer_url: null,
    original_tour_price: 5899,
    predicted_total_pax: '10.1',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -176.97,
    after_price: 5722.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-04-25|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 4,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.167,
    hedged_pax: 56.0,
    departure_date: '2026-04-25',
    handback_date: '2026-03-11',
    leadtime: 30,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '11.9',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-05-02|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 7,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.292,
    hedged_pax: 56.0,
    departure_date: '2026-05-02',
    handback_date: '2026-03-18',
    leadtime: 30,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '20.8',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-05-09|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 7,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.292,
    hedged_pax: 56.0,
    departure_date: '2026-05-09',
    handback_date: '2026-03-25',
    leadtime: 30,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '20.8',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-05-13|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 3,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.125,
    hedged_pax: 56.0,
    departure_date: '2026-05-13',
    handback_date: '2026-03-29',
    leadtime: 30,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '8.9',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-05-20|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 3,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.125,
    hedged_pax: 56.0,
    departure_date: '2026-05-20',
    handback_date: '2026-04-05',
    leadtime: 60,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '9.4',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-06-08|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 5,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.208,
    hedged_pax: 56.0,
    departure_date: '2026-06-08',
    handback_date: '2026-04-24',
    leadtime: 60,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '15.7',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-06-13|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.042,
    hedged_pax: 56.0,
    departure_date: '2026-06-13',
    handback_date: '2026-04-29',
    leadtime: 60,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '3.1',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-07-08|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.042,
    hedged_pax: 56.0,
    departure_date: '2026-07-08',
    handback_date: '2026-05-24',
    leadtime: 90,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '3.7',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-07-18|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.042,
    hedged_pax: 56.0,
    departure_date: '2026-07-18',
    handback_date: '2026-06-03',
    leadtime: 120,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '4.4',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-09-02|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 2,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.083,
    hedged_pax: 56.0,
    departure_date: '2026-09-02',
    handback_date: '2026-07-19',
    leadtime: 150,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '10.6',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-09-08|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 2,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.083,
    hedged_pax: 56.0,
    departure_date: '2026-09-08',
    handback_date: '2026-07-25',
    leadtime: 150,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '10.6',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '0318af60-7252-42ce-8299-d3be953fe50c|2026-09-12|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0318af60-7252-42ce-8299-d3be953fe50c',
    offer_country_name: 'Vietnam',
    max_pax: 24.0,
    offer_name: 'LTLE - 10D Deluxe Vietnam + 5N Radisson Blu Resort Phu Quoc',
    offer_salesforce_bk: '006RF00000OXRN1YAP',
    departure_name: 'Sample Departure',
    total_pax_sold: 2,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.083,
    hedged_pax: 56.0,
    departure_date: '2026-09-12',
    handback_date: '2026-07-29',
    leadtime: 150,
    offer_url: null,
    original_tour_price: 3299,
    predicted_total_pax: '10.6',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -98.97,
    after_price: 3200.03,
  },
  {
    suggestion_id: '04ee41d8-addd-4799-8891-65523b25b518|2026-04-05|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '04ee41d8-addd-4799-8891-65523b25b518',
    offer_country_name: 'Vietnam',
    max_pax: 16.0,
    offer_name: '11D Premium Vietnam Food Tour - Insider Series (2026 + 2027)',
    offer_salesforce_bk: '006RF00000LcxZIYAZ',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.0625,
    hedged_pax: 32.0,
    departure_date: '2026-04-05',
    handback_date: '2026-02-12',
    leadtime: 0,
    offer_url: null,
    original_tour_price: 4199,
    predicted_total_pax: '2.3',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -125.97,
    after_price: 4073.03,
  },
  {
    suggestion_id: '04ee41d8-addd-4799-8891-65523b25b518|2026-04-19|surcharge|0.03',
    suggested_action_type: 'surcharge',
    distance_category: 'close',
    offer_bk: '04ee41d8-addd-4799-8891-65523b25b518',
    offer_country_name: 'Vietnam',
    max_pax: 16.0,
    offer_name: '11D Premium Vietnam Food Tour - Insider Series (2026 + 2027)',
    offer_salesforce_bk: '006RF00000LcxZIYAZ',
    departure_name: 'Sample Departure',
    total_pax_sold: 7,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.4375,
    hedged_pax: 32.0,
    departure_date: '2026-04-19',
    handback_date: '2026-02-26',
    leadtime: 30,
    offer_url: null,
    original_tour_price: 4199,
    predicted_total_pax: 'Predicted Sold Out',
    suggested_price_change_percent: 0.03,
    suggested_price_change_amount: 125.97,
    after_price: 4324.97,
  },
  {
    suggestion_id: '04ee41d8-addd-4799-8891-65523b25b518|2026-05-23|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '04ee41d8-addd-4799-8891-65523b25b518',
    offer_country_name: 'Vietnam',
    max_pax: 16.0,
    offer_name: '11D Premium Vietnam Food Tour - Insider Series (2026 + 2027)',
    offer_salesforce_bk: '006RF00000LcxZIYAZ',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.0625,
    hedged_pax: 32.0,
    departure_date: '2026-05-23',
    handback_date: '2026-04-01',
    leadtime: 60,
    offer_url: null,
    original_tour_price: 4199,
    predicted_total_pax: '2.4',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -125.97,
    after_price: 4073.03,
  },
  {
    suggestion_id: '04ee41d8-addd-4799-8891-65523b25b518|2026-06-14|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '04ee41d8-addd-4799-8891-65523b25b518',
    offer_country_name: 'Vietnam',
    max_pax: 16.0,
    offer_name: '11D Premium Vietnam Food Tour - Insider Series (2026 + 2027)',
    offer_salesforce_bk: '006RF00000LcxZIYAZ',
    departure_name: 'Sample Departure',
    total_pax_sold: 2,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.125,
    hedged_pax: 32.0,
    departure_date: '2026-06-14',
    handback_date: '2026-04-23',
    leadtime: 60,
    offer_url: null,
    original_tour_price: 4199,
    predicted_total_pax: '4.8',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -125.97,
    after_price: 4073.03,
  },
  {
    suggestion_id: '04ee41d8-addd-4799-8891-65523b25b518|2026-08-16|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '04ee41d8-addd-4799-8891-65523b25b518',
    offer_country_name: 'Vietnam',
    max_pax: 16.0,
    offer_name: '11D Premium Vietnam Food Tour - Insider Series (2026 + 2027)',
    offer_salesforce_bk: '006RF00000LcxZIYAZ',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.0625,
    hedged_pax: 32.0,
    departure_date: '2026-08-16',
    handback_date: '2026-06-25',
    leadtime: 150,
    offer_url: null,
    original_tour_price: 4199,
    predicted_total_pax: '3.7',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -125.97,
    after_price: 4073.03,
  },
  {
    suggestion_id: '04ee41d8-addd-4799-8891-65523b25b518|2026-10-18|surcharge|0.03',
    suggested_action_type: 'surcharge',
    distance_category: 'close',
    offer_bk: '04ee41d8-addd-4799-8891-65523b25b518',
    offer_country_name: 'Vietnam',
    max_pax: 16.0,
    offer_name: '11D Premium Vietnam Food Tour - Insider Series (2026 + 2027)',
    offer_salesforce_bk: '006RF00000LcxZIYAZ',
    departure_name: 'Sample Departure',
    total_pax_sold: 5,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.3125,
    hedged_pax: 32.0,
    departure_date: '2026-10-18',
    handback_date: '2026-08-27',
    leadtime: 210,
    offer_url: null,
    original_tour_price: 4199,
    predicted_total_pax: 'Predicted Sold Out',
    suggested_price_change_percent: 0.03,
    suggested_price_change_amount: 125.97,
    after_price: 4324.97,
  },
  {
    suggestion_id: '04fde0be-2d08-4c05-91dc-f9313330efa6|2026-05-06|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '04fde0be-2d08-4c05-91dc-f9313330efa6',
    offer_country_name: 'Japan',
    max_pax: 24.0,
    offer_name: 'LTLE - 7Day Japan SOLO campaign with no solo supplement',
    offer_salesforce_bk: '006RF00000QVeqEYAT',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 2',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.042,
    hedged_pax: 144.0,
    departure_date: '2026-05-06',
    handback_date: '2026-03-07',
    leadtime: 30,
    offer_url: null,
    original_tour_price: 2799,
    predicted_total_pax: '2.5',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -83.97,
    after_price: 2715.03,
  },
  {
    suggestion_id: '04fde0be-2d08-4c05-91dc-f9313330efa6|2026-09-16|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '04fde0be-2d08-4c05-91dc-f9313330efa6',
    offer_country_name: 'Japan',
    max_pax: 24.0,
    offer_name: 'LTLE - 7Day Japan SOLO campaign with no solo supplement',
    offer_salesforce_bk: '006RF00000QVeqEYAT',
    departure_name: 'Sample Departure',
    total_pax_sold: 2,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 2',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.083,
    hedged_pax: 144.0,
    departure_date: '2026-09-16',
    handback_date: '2026-07-18',
    leadtime: 180,
    offer_url: null,
    original_tour_price: 2799,
    predicted_total_pax: '10.2',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -83.97,
    after_price: 2715.03,
  },
  {
    suggestion_id: '04fde0be-2d08-4c05-91dc-f9313330efa6|2026-09-23|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '04fde0be-2d08-4c05-91dc-f9313330efa6',
    offer_country_name: 'Japan',
    max_pax: 24.0,
    offer_name: 'LTLE - 7Day Japan SOLO campaign with no solo supplement',
    offer_salesforce_bk: '006RF00000QVeqEYAT',
    departure_name: 'Sample Departure',
    total_pax_sold: 3,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 2',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.125,
    hedged_pax: 144.0,
    departure_date: '2026-09-23',
    handback_date: '2026-07-25',
    leadtime: 180,
    offer_url: null,
    original_tour_price: 2799,
    predicted_total_pax: '15.3',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -83.97,
    after_price: 2715.03,
  },
  {
    suggestion_id: '07a67990-851c-40d6-b470-6892951f0e27|2026-09-18|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '07a67990-851c-40d6-b470-6892951f0e27',
    offer_country_name: 'India',
    max_pax: 16.0,
    offer_name: '(LTLE) - 15D Ultimate India Luxury North & South India with 3n Goa Beach Stay',
    offer_salesforce_bk: '006RF00000KkrgvYAB',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 4 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.0625,
    hedged_pax: 40.0,
    departure_date: '2026-09-18',
    handback_date: '2026-07-13',
    leadtime: 180,
    offer_url: null,
    original_tour_price: 4999,
    predicted_total_pax: '5.1',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -149.97,
    after_price: 4849.03,
  },
  {
    suggestion_id: '0893557b-46e6-42f6-b0ef-09265809cd5d|2026-05-06|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0893557b-46e6-42f6-b0ef-09265809cd5d',
    offer_country_name: 'Turkey',
    max_pax: 30.0,
    offer_name: '4D Cappadocia Extension for private charter tour 2026',
    offer_salesforce_bk: '006RF00000N7xULYAZ',
    departure_name: 'Sample Departure',
    total_pax_sold: 6,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.2,
    hedged_pax: 8.0,
    departure_date: '2026-05-06',
    handback_date: '2026-02-28',
    leadtime: 30,
    offer_url: null,
    original_tour_price: 1599,
    predicted_total_pax: '28.9',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -47.97,
    after_price: 1551.03,
  },
  {
    suggestion_id: '0a879180-14b6-4c2b-ba2d-350bb973d6d3|2026-04-07|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0a879180-14b6-4c2b-ba2d-350bb973d6d3',
    offer_country_name: 'Vietnam',
    max_pax: 15.0,
    offer_name: '14D Vietnam/Cambodia - Lifestyle - 2026',
    offer_salesforce_bk: '006RF00000LtjrfYAB',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.067,
    hedged_pax: 8.0,
    departure_date: '2026-04-07',
    handback_date: '2026-02-16',
    leadtime: 0,
    offer_url: null,
    original_tour_price: 3799,
    predicted_total_pax: '3',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -113.97,
    after_price: 3685.03,
  },
  {
    suggestion_id: '0a879180-14b6-4c2b-ba2d-350bb973d6d3|2026-05-22|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0a879180-14b6-4c2b-ba2d-350bb973d6d3',
    offer_country_name: 'Vietnam',
    max_pax: 15.0,
    offer_name: '14D Vietnam/Cambodia - Lifestyle - 2026',
    offer_salesforce_bk: '006RF00000LtjrfYAB',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.067,
    hedged_pax: 8.0,
    departure_date: '2026-05-22',
    handback_date: '2026-04-02',
    leadtime: 60,
    offer_url: null,
    original_tour_price: 3799,
    predicted_total_pax: '3.1',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -113.97,
    after_price: 3685.03,
  },
  {
    suggestion_id: '0a879180-14b6-4c2b-ba2d-350bb973d6d3|2026-06-17|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0a879180-14b6-4c2b-ba2d-350bb973d6d3',
    offer_country_name: 'Vietnam',
    max_pax: 15.0,
    offer_name: '14D Vietnam/Cambodia - Lifestyle - 2026',
    offer_salesforce_bk: '006RF00000LtjrfYAB',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.067,
    hedged_pax: 8.0,
    departure_date: '2026-06-17',
    handback_date: '2026-04-28',
    leadtime: 90,
    offer_url: null,
    original_tour_price: 3799,
    predicted_total_pax: '3.7',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -113.97,
    after_price: 3685.03,
  },
  {
    suggestion_id: '0a879180-14b6-4c2b-ba2d-350bb973d6d3|2026-07-07|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0a879180-14b6-4c2b-ba2d-350bb973d6d3',
    offer_country_name: 'Vietnam',
    max_pax: 15.0,
    offer_name: '14D Vietnam/Cambodia - Lifestyle - 2026',
    offer_salesforce_bk: '006RF00000LtjrfYAB',
    departure_name: 'Sample Departure',
    total_pax_sold: 1,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.067,
    hedged_pax: 8.0,
    departure_date: '2026-07-07',
    handback_date: '2026-05-18',
    leadtime: 90,
    offer_url: null,
    original_tour_price: 3799,
    predicted_total_pax: '3.7',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -113.97,
    after_price: 3685.03,
  },
  {
    suggestion_id: '0d5093f4-f3b8-497a-b1c1-4e7dc32610d1|2026-05-17|discount|-0.03',
    suggested_action_type: 'discount',
    distance_category: 'far',
    offer_bk: '0d5093f4-f3b8-497a-b1c1-4e7dc32610d1',
    offer_country_name: 'Thailand',
    max_pax: 16.0,
    offer_name: 'LTLE - 12D Deluxe Best of Northern Thailand with No Solo Supplement',
    offer_salesforce_bk: '006RF00000QCfZxYAL',
    departure_name: 'Sample Departure',
    total_pax_sold: 2,
    hidden_departure_status: 'not_hidden',
    ddop_status: 'Active 2 Inactive 0',
    cloned_from_departure_salesforce_bk: null,
    cloned_from_departure_name: null,
    current_book_rate: 0.125,
    hedged_pax: 36.0,
    departure_date: '2026-05-17',
    handback_date: '2026-03-18',
    leadtime: 30,
    offer_url: null,
    original_tour_price: 2499,
    predicted_total_pax: '4.6',
    suggested_price_change_percent: -0.03,
    suggested_price_change_amount: -74.97,
    after_price: 2424.03,
  },
];

export const TOURS_PRICING_SAMPLE_DATA: Array<LereToursPricingSuggestion> = TOURS_PRICING_BASE_SAMPLE_DATA.map(
  (sample, index) => {
    const { after_price, ...suggestion } = sample;

    return {
      ...suggestion,
      departure_salesforce_bk: `sample-departure-salesforce-bk-${index + 1}`,
      suggested_after_price: after_price,
      price_direction: after_price > (sample.current_tour_price ?? sample.original_tour_price) + 0.005
        ? 'surcharge'
        : after_price < (sample.current_tour_price ?? sample.original_tour_price) - 0.005
          ? 'discount'
          : 'none',
      reason_headline: index % 2 === 0 ? 'Selling well' : 'Unlikely to reach hedge',
      reason_points: [
        `${sample.total_pax_sold} of ${sample.max_pax} sold`,
        'No bookings yet',
        'No add to carts for this date in 4 weeks',
      ],
      sales_at_current_price: sample.sales_at_current_price ?? sample.total_pax_sold,
      current_tour_price: sample.current_tour_price ?? sample.original_tour_price,
      current_price_delta_percent: sample.current_price_delta_percent ?? 0,
      days_since_last_sale: sample.days_since_last_sale ?? null,
      note: index % 3 === 0 ? 'Sample note for tours dynamic pricing review.' : null,
    };
  },
);

const SAMPLE_HISTORY_USERS = [
  { created_by_user_id: 'sample-user-1', created_by_username: 'Sample Analyst' },
  { created_by_user_id: 'sample-user-2', created_by_username: 'Revenue Manager' },
  { created_by_user_id: 'sample-user-3', created_by_username: 'Pricing Operator' },
] as const;

export const TOURS_PRICING_HISTORY_SAMPLE_DATA: Array<LereToursPricingHistoryRecord> = TOURS_PRICING_SAMPLE_DATA.map(
  (sample, index) => {
    const sampleUser = SAMPLE_HISTORY_USERS[index % SAMPLE_HISTORY_USERS.length];

    return {
      id: `sample-history-${index + 1}`,
      suggestion_id: sample.suggestion_id,
      offer_bk: sample.offer_bk,
      offer_url: sample.offer_url,
      offer_salesforce_bk: sample.offer_salesforce_bk,
      offer_name: sample.offer_name,
      departure_date: sample.departure_date,
      departure_name: sample.departure_name,
      suggested_action_type: sample.suggested_action_type,
      applied_action_type: sample.suggested_action_type,
      distance_category: sample.distance_category,
      original_tour_price: sample.original_tour_price,
      suggested_price_change_percent: sample.suggested_price_change_percent,
      suggested_after_price: sample.suggested_after_price,
      applied_price_change_percent: sample.suggested_price_change_percent,
      applied_after_price: sample.suggested_after_price,
      total_pax_sold: sample.total_pax_sold,
      max_pax: sample.max_pax,
      leadtime: sample.leadtime,
      status: index % 4 === 0 ? 'rejected' : 'applied',
      note: sample.note,
      created_by_user_id: sampleUser.created_by_user_id,
      created_by_username: sampleUser.created_by_username,
      created_at: `2026-01-${String((index % 28) + 1).padStart(2, '0')}T10:00:00Z`,
    };
  },
);
